import { formatNumber, formatSAR } from "@/utils/format";

interface AppFeesSummaryProps {
  total: number;
  orders: number;
  perOrder: number;
  electronic: number;
  electronicOrders: number;
  cash: number;
  cashOrders: number;
}

export default function AppFeesSummary({
  total,
  orders,
  perOrder,
  electronic,
  electronicOrders,
  cash,
  cashOrders,
}: AppFeesSummaryProps) {
  const rows = [
    {
      label: "إجمالي رسوم التطبيق (يتحمّلها العميل)",
      value: formatSAR(total),
      icon: "ri-smartphone-line",
      tone: "bg-accent-100 text-accent-800",
    },
    {
      label: "عدد طلبات التطبيق",
      value: formatNumber(orders),
      icon: "ri-shopping-bag-3-line",
      tone: "bg-secondary-200 text-secondary-800",
    },
    {
      label: "الرسوم لكل طلب",
      value: formatSAR(perOrder),
      icon: "ri-scales-3-line",
      tone: "bg-primary-100 text-primary-700",
    },
  ];

  const breakdown = [
    {
      label: "محصّلة إلكترونيًا لصالح المنصة",
      hint: "لا تُخصم من مستحقات المحل",
      count: electronicOrders,
      value: electronic,
      icon: "ri-bank-card-line",
      tone: "bg-primary-100 text-primary-700",
      valueClass: "text-foreground-950",
    },
    {
      label: "مضافة إلى رسوم التطبيق المستحقة لطلبات الكاش",
      hint: "لأن المحل حصّلها من العميل",
      count: cashOrders,
      value: cash,
      icon: "ri-hand-coin-line",
      tone: "bg-red-100 text-red-600",
      valueClass: "text-foreground-950",
    },
  ];

  return (
    <section className="yc-fade-up yc-card-hover bg-white rounded-card border border-background-200 shadow-card p-5">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-800">
          <i className="ri-smartphone-line"></i>
        </span>
        <h3 className="text-base font-bold text-foreground-950">
          رسوم التطبيق
        </h3>
      </div>

      <ul className="space-y-2 text-sm">
        {rows.map((item) => (
          <li
            key={item.label}
            className="flex items-center justify-between rounded-btn bg-background-50 px-4 py-3"
          >
            <span className="inline-flex items-center gap-2 text-foreground-600">
              <span
                className={`w-7 h-7 flex items-center justify-center rounded-full text-sm ${item.tone}`}
              >
                <i className={item.icon}></i>
              </span>
              {item.label}
            </span>
            <span className="font-bold text-foreground-950">{item.value}</span>
          </li>
        ))}
      </ul>

      <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2">
        {breakdown.map((item) => (
          <div
            key={item.label}
            className="rounded-btn border border-background-200 bg-white px-4 py-3"
          >
            <div className="flex items-center gap-2">
              <span
                className={`w-7 h-7 flex items-center justify-center rounded-full text-sm ${item.tone}`}
              >
                <i className={item.icon}></i>
              </span>
              <span className="text-sm font-semibold text-foreground-800">
                {item.label}
              </span>
            </div>
            <p className="mt-2 text-xs text-foreground-500">
              {item.count} طلب — {item.hint}
            </p>
            <p className={`mt-1 text-base font-bold ${item.valueClass}`}>
              {formatSAR(item.value)}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-4 rounded-btn border border-accent-200 bg-accent-50 px-4 py-3 text-xs leading-6 text-foreground-600">
        رسوم التطبيق 0.80 ر.س يتحملها العميل على الطلبات المنشأة من تطبيق يور
        كاشير. تُحصّل إلكترونيًا لصالح المنصة، وفي طلبات الكاش فقط تُضاف إلى رسوم
        التطبيق المستحقة على المحل لطلبات الكاش لأنه حصّلها من العميل.
      </div>
    </section>
  );
}